import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { App, ConfigProvider } from "antd";
import enUS from "antd/locale/en_US";
import zhCN from "antd/locale/zh_CN";
import jaJP from "antd/locale/ja_JP";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import "dayjs/locale/en";
import { Helmet, Outlet, setLocale } from "@umijs/max";
import { DEFAULT_SPIRAL_APP_THEME, setGlobalThemeConfig } from "@spiral-app/core";
import { TiLocale } from "../types";
import useTiMaxStore from "../hooks/useTiMaxStore";
import { useAppStore } from "../hooks/useApp";
const localeMap = {
  [TiLocale.ZH_CN]: {
    antd: zhCN,
    dayjs: "zh-cn"
  },
  [TiLocale.EN_US]: {
    antd: enUS,
    dayjs: "en"
  },
  [TiLocale.JA_JP]: {
    antd: jaJP,
    dayjs: "ja"
  }
};
const Sub = ({ context }) => {
  const app = App.useApp();
  const { app: maxApp, setApp } = useAppStore();
  useEffect(() => {
    setApp(app);
  }, []);
  if (!maxApp) {
    return;
  }
  return /* @__PURE__ */ jsx(Outlet, { context });
};
const TiBasicLayout = ({ title, logo, prefixCls, theme }) => {
  const [locale, setLocal] = useState(enUS);
  const { locale: tiLocale } = useTiMaxStore();
  useEffect(() => {
    setGlobalThemeConfig({
      antdTheme: theme || DEFAULT_SPIRAL_APP_THEME
    });
  }, []);
  useEffect(() => {
    switchLocale();
  }, [tiLocale]);
  const switchLocale = () => {
    setLocal(localeMap[tiLocale].antd);
    dayjs.locale(localeMap[tiLocale].dayjs);
    setLocale(tiLocale, false);
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(Helmet, { children: [
      /* @__PURE__ */ jsx("meta", { charSet: "utf-8" }),
      /* @__PURE__ */ jsx("title", { children: title })
    ] }),
    /* @__PURE__ */ jsx(
      ConfigProvider,
      {
        prefixCls: prefixCls || process.env.APP_NAME,
        theme: theme || DEFAULT_SPIRAL_APP_THEME,
        locale,
        children: /* @__PURE__ */ jsx(App, { children: /* @__PURE__ */ jsx(
          Sub,
          {
            context: {
              title,
              logo
            }
          }
        ) })
      }
    )
  ] });
};
var TiBasicLayout_default = TiBasicLayout;
export {
  TiBasicLayout_default as default
};
